import { apiFetch } from './prospects.js';

export function fetchCrmMailPackOffer() {
  return apiFetch('/mail-pack/offers');
}

export function quoteCrmMailPack(affiliateCode) {
  return apiFetch('/mail-pack/quote', {
    method: 'POST',
    body: JSON.stringify({
      affiliateCode: affiliateCode?.trim() || undefined,
    }),
  });
}

export function createCrmMailPackCheckout({ returnUrl, affiliateCode } = {}) {
  return apiFetch('/mail-pack/checkout', {
    method: 'POST',
    body: JSON.stringify({
      returnUrl: returnUrl ? String(returnUrl) : undefined,
      affiliateCode: affiliateCode?.trim() || undefined,
    }),
  });
}

export function confirmCrmMailPackPayment(paymentId) {
  return apiFetch('/mail-pack/confirm', {
    method: 'POST',
    body: JSON.stringify({ paymentId: String(paymentId ?? '').trim() }),
  });
}
